import { Box, useMediaQuery, useTheme } from "@mui/material";
import {
	IEnhancedMenuItem,
	IHeading,
	ISeparator,
	ITest,
} from "@websential/cosmic-v20";
import { profileMenuItemsArraySuperUser, profileMenuItemsArraySuperUserMobile } from "./ProfileMenuItems";

import Avatar from "@mui/material/Avatar";
import { EnhancedMenu } from "./EnhancedMenu";
import { FC } from "react";
import { IAppState } from "../../store/reducers";
import { useSelector } from "react-redux";

const maxChartactersToDisplay = 15;

export interface IProfileMenuProps extends ITest {
	/**
	 * Name of the user to be displayed; if length  > 15 then it will be truncated
	 */
	userProfileName: string;
	/**
	 * Profile picture URL to be displayed; if not provided then default user picture will be displayed
	 */
	userProfilePictureURL?: string;
	/** Optional second line under the title, e.g. "Payroll Administrator" */
	menuSubtitleText?: string;
	/** Optional third line, e.g. "Last login Sep 21, 2026 · 9:12 AM ET" */
	menuCaptionText?: string;
}

export const ProfileMenu: FC<IProfileMenuProps> = ({
	userProfileName,
	userProfilePictureURL,
	testId,
	menuSubtitleText,
	menuCaptionText
}: IProfileMenuProps) => {
	const clientId = useSelector((state: IAppState) => state.client.id);
	const truncate = (str: string, n: number) => {
		return str && str.length > n ? str.substring(0, n) + "..." : str;
	};

	const profileMenuItemsArray: (IEnhancedMenuItem | ISeparator | IHeading)[] = [
		{
			label: "Profile",
			navigateTo: `/clients/setup/${clientId}`,
		},
		// {
		//   label: "Default Settings",
		//   navigateTo: '/me/default-settings',
		// },
		// {
		//   label: "API",
		//   navigateTo: '/me/api',
		// },
		// {
		//   label: "Users",
		//   navigateTo: '/invite/user',
		// },
		{
			label: "Change Password",
			navigateTo: "/me/change-password",
		},
		// {
		// 	label: "Logout",
		// 	navigateTo: "/logout",
		// },
	];

	const profileMenuItemsArrayForMobileScreen: (IEnhancedMenuItem | ISeparator | IHeading)[] = [
		{
			label: "Profile",
			navigateTo: `/clients/setup/${clientId}`,
		},
		// {
		//   label: "Default Settings",
		//   navigateTo: '/me/default-settings',
		// },
		// {
		//   label: "API",
		//   navigateTo: '/me/api',
		// },
		// {
		//   label: "Users",
		//   navigateTo: '/invite/user',
		// },
		{
			label: "Change Password",
			navigateTo: "/me/change-password",
		},
		{
			label: "Logout",
			navigateTo: "/logout",
		},
		// {
		// 	label: "Logout",
		// 	navigateTo: "/logout",
		// },
	];

	const theme = useTheme();
	const isMobileScreen = useMediaQuery(theme.breakpoints.down("sm"));
	const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
	const isMediumScreen0 = useMediaQuery(theme.breakpoints.between(900, 1195));
	const isMediumScreen01 = useMediaQuery(theme.breakpoints.between(900, 1200));

	return (
		<Box
			sx={{
				"& .MuiButtonBase-root": {
					color: "#ffffff",
					textTransform: "capitalize",
					paddingRight: isMobileScreen ? 0 : "8px",
					paddingBottom: isMobileScreen ? "18px" : "8px",
					paddingTop: isMobileScreen ? "14px" : "10px",
					// paddingBottom: { xs: "14px" }
				},
				"& .MuiTypography-body2": {
					display: { xs: "none", sm: "flex", md: "flex", lg: "flex", xl: "flex" }
				},
				"& .MuiButton-icon": {
					marginX: isMobileScreen ? 0 : "8px"
				},
				"& .MuiButtonBase-root .MuiAvatar-root": {
					width: isMobileScreen ? "32px" : "40px",
					height: isMobileScreen ? "32px" : "40px"
				},
				"& .MuiButtonBase-root .MuiAvatar-root .MuiSvgIcon-root": {
					width: isMobileScreen ? "69%" : "75%",
					height: isMobileScreen ? "67%" : "75%"
				},
			}}
		>
			<EnhancedMenu
				menuTitleText={truncate(userProfileName, maxChartactersToDisplay)}
				menuTitleBackgroundColor="primary"
				variant="text"
				testId={testId}
				startIcon={
					<Avatar alt={userProfileName} src={userProfilePictureURL ?? ""} />
				}
				showEndIcon={true}
				menuItems={
					clientId !== "" && !isMobileScreen
						? profileMenuItemsArray :
						clientId !== "" && isMobileScreen
							? profileMenuItemsArrayForMobileScreen
							: isMobileScreen ? profileMenuItemsArraySuperUserMobile : profileMenuItemsArraySuperUser
				}
				menuSubtitleText={menuSubtitleText}
				menuCaptionText={menuCaptionText}
			/>
		</Box>
	);
};
